import { withStyles } from '@material-ui/core'
import React, { useState } from 'react'
import styles from './styles'
import { useDispatch } from 'react-redux'
import {
  AccessTeams,
  OptIn,
  MagicViewContent,
  EveryoneAccess,
} from './components'
import { patchCollectionSettingsAction } from 'src/reducers/course-collection/action'
import { useSelector } from 'react-redux'
import { PatchContent, PatchData } from 'src/model/patch'
import UserType from 'src/model/user-types'
import { track } from '@amplitude/analytics-browser'

const names = {
  0: 'Everyone',
  1: 'Opt-in',
  2: 'Specific Teams',
}
const GeneralSettings = props => {
  const {
    classes,
    entity,
    setCollectionSettingDrawerOpen,
    magicLink,
    setMagicLink,
  } = props
  const collectionSettings = useSelector(
    state => state.courseCollectionList.collectionSettings,
  )

  const [accessRule, setAccessRule] = useState(collectionSettings.accessRule)

  const userControl = UserType[window.CONSTANTS.USER_ROLE_ID]

  const dispatch = useDispatch()

  const handleSaveAccessSelection = value => {
    const patchSource = new PatchData(null, entity.id)
    patchSource.addContent(
      new PatchContent(value, 'accessRule', PatchData.OPERATION_REPLACE),
    )

    dispatch(
      patchCollectionSettingsAction(patchSource, response => {
        track('Access Rule Changed', {
          from: names[value],
        })
      }),
    )
  }

  /*const handleSave = () => {
    setCollectionSettingDrawerOpen(false)
  }*/

  const handleBack = () => {
    setMagicLink(false)
  }

  const appInAuthUsersControl = () => {
    if (
      userControl == 'Premium Plus' ||
      userControl == 'Premium Plus v2' ||
      userControl == 'Premium - A'
    ) {
      return false
    }
    return true
  }

  const handleAccessRule = value => {
    let userAccessControl = false

    if (value == 3) {
      userAccessControl = appInAuthUsersControl()
      if (userAccessControl) {
        //window.location.href = '/pricing'
      }
    }

    if (value != accessRule) {
      setAccessRule(value)
      handleSaveAccessSelection(value)
    }
  }

  const handleMagicLink = () => {
    setMagicLink(!magicLink)
  }

  const closeDrawer = () => {
    setCollectionSettingDrawerOpen(false)
  }

  const components = [
    {
      component: (
        <EveryoneAccess
          accessRule={accessRule}
          handleAccessRule={handleAccessRule}
        />
      ),
      onView: !magicLink,
      mainPage: true,
    },
    {
      component: (
        <OptIn
          entity={entity}
          accessRule={accessRule}
          handleAccessRule={handleAccessRule}
        />
      ),
      onView: !magicLink,
      mainPage: true,
    },

    {
      component: (
        <AccessTeams
          entity={entity}
          accessRule={accessRule}
          handleAccessRule={handleAccessRule}
          dispatch={dispatch}
          handleMagicLink={handleMagicLink}
        />
      ),
      onView: !magicLink,
      mainPage: true,
    },
    {
      component: (
        <MagicViewContent
          entity={entity}
          accessRule={accessRule}
          handleBack={handleBack}
          closeDrawer={closeDrawer}
          collectionSettings={collectionSettings}
        />
      ),
      onView: magicLink,
      mainPage: false,
    },
  ]
  return (
    <div className={classes.content}>
      <div className={classes.content__components}>
        {components.map(
          (component, index) =>
            component.onView && (
              <div
                key={index}
                style={{
                  borderBottom: component.mainPage
                    ? '1px solid rgba(145, 158, 171, 0.32)'
                    : 'none',
                }}
              >
                {component.component}
              </div>
            ),
        )}
      </div>
    </div>
  )
}

export default withStyles(styles)(GeneralSettings)
